// src/components/RatingButtons.js
import React, { useState } from "react";
import InfoButton from "./InfoButton";
import Popup from "./PopUp";
import "../assets/css/questionpages.css";

// small hook in-file for brevity:
const useIsMobile = (breakpoint = 768) => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= breakpoint : false
  );

  React.useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= breakpoint);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [breakpoint]);

  return isMobile;
};

const RatingButtons = ({
  questionText,
  questionId,
  scoreValue,
  targetValue,
  onScoreSelect,
  onTargetSelect,
  notes,
}) => {
  const [openPopup, setOpenPopup] = useState(null); // "score" or "target"
  const isMobile = useIsMobile();
  const selected = scoreValue !== undefined;

  // debug: remove when confirmed working
  // console.log("RatingButtons", { questionId, isMobile, openPopup });

  return (
    <>
      <div className="question-row">
        <div className="question-text">{questionText}</div>

        <div className={`rating-options ${selected ? "faded" : ""}`}>
          {notes ? (
            <InfoButton notes={notes} />
          ) : (
            <div style={{ width: "42px" }} />
          )}

          {/* SCORE */}
          <div className="rating-col">
            <span className="mobile-label" style={{ color: "#7C8C27" }}>
              Score
            </span>

            {isMobile ? (
              <button
                type="button"
                className="mobile-popup-trigger rating-score"
                onClick={() => {
                  // debug
                  // console.log('open score popup');
                  setOpenPopup("score");
                }}
                aria-expanded={openPopup === "score"}
              >
                {scoreValue ?? 1}
              </button>
            ) : (
              <select
                className="rating-dropdown rating-score score-select"
                value={scoreValue ?? 1}
                onChange={(e) =>
                  onScoreSelect(questionId, Number(e.target.value || 0))
                }
              >
                <option value={1}>1 Is it in somebody's head?</option>
                <option value={2}>
                  2 Is it written down and formally agreed?
                </option>
                <option value={3}>
                  3 Is it measured against an organisational objective?
                </option>
                <option value={4}>4 Is it optimised?</option>
              </select>
            )}
          </div>

          {/* TARGET */}
          <div className="rating-col">
            <span className="mobile-label" style={{ color: "#725581" }}>
              Target
            </span>

            {isMobile ? (
              <button
                type="button"
                className="mobile-popup-trigger rating-target"
                onClick={() => {
                  // console.log('open target popup');
                  setOpenPopup("target");
                }}
                aria-expanded={openPopup === "target"}
              >
                {targetValue}
              </button>
            ) : (
              <select
                className="rating-dropdown rating-target target-select"
                value={targetValue}
                onChange={(e) =>
                  onTargetSelect(questionId, Number(e.target.value || 0))
                }
              >
                <option value={1}>1 Is it in somebody's head?</option>
                <option value={2}>
                  2 Is it written down and formally agreed?
                </option>
                <option value={3}>
                  3 Is it measured against an organisational objective?
                </option>
                <option value={4}>4 Is it optimised?</option>
              </select>
            )}
          </div>
        </div>
      </div>

      {/* POPUPS — keep them outside the .question-row (already here) */}
      {/* SCORE POPUP */}
      <Popup
        isOpen={openPopup === "score"}
        mode="score"
        questionText={questionText}
        initialValue={scoreValue}
        onConfirm={(val) => onScoreSelect(questionId, val)}
        onClose={() => setOpenPopup(null)}
      />

      <Popup
        isOpen={openPopup === "target"}
        mode="target"
        questionText={questionText}
        initialValue={targetValue}
        onConfirm={(val) => onTargetSelect(questionId, val)}
        onClose={() => setOpenPopup(null)}
      />
    </>
  );
};

export default RatingButtons;
